import { FormBuilder } from "components/FormBuilder/FormBuilder";
import React from 'react'
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import transactionCurrencyOptions from "utils/transactionCurrencyOptions/TransactionCurrencyOptions";

/**
 * @param {Object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {boolean} props.isCreate
 * @param {boolean} props.isEditing
 * @param {boolean} props.isLoading
 */
const OnlineMerchantManagementUsdSettlementSection = ({
  formProps,
  isCreate,
  isEditing,
  isLoading
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.merchant.usdSettlementSection" });
  const { t: tCommon } = useTranslation();

  const settleByUsd = useWatch({ control: formProps.control, name: "usdSettleCurrency" }) === "USD";

  const isDisabled = isLoading;
  const isReadOnly = !isCreate && !isEditing;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    usdSettleCurrency: {
      fieldType: "selection",
      fieldName: "usdSettleCurrency",
      label: tLocal("label.usdSettleCurrency"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        options: transactionCurrencyOptions(["HKD", "USD"]),
        defaultValue: "HKD",
      }
    },

    // Only shown when currencyList includes USD and USD transactions are settled with USD 
    usdBankAccount: {
      fieldType: "textInput",
      fieldName: "usdBankAccount",
      label: tLocal("label.usdBankAccount"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        rules: ["validBankAccount"]
      }
    },
    usdBeneficiary: {
      fieldType: "textInput",
      fieldName: "usdBeneficiary",
      label: tLocal("label.usdBeneficiary"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        maxLength: 140,
        rules: ["onlyBlockLetter",
          "noLeadingWhitespace",
          "validBankBeneficiary",]
      }
    },
    usdGatewayFee: {
      fieldType: "textInput",
      fieldName: "usdGatewayFee",
      label: tLocal("label.usdGatewayFee"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: 1.2,
        asNumber: true,
        rules: ["onlyPositiveNumber", "maxTwoDecimal"]
      }
    },
    usdTokenFee: {
      fieldType: "textInput",
      fieldName: "usdTokenFee",
      label: tLocal("label.usdTokenFee"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: 0.4,
        asNumber: true,
        rules: ["onlyPositiveNumber", "maxTwoDecimal"]
      }
    },
    usdThreeDSFee: {
      fieldType: "textInput",
      fieldName: "usdThreeDSFee",
      label: tLocal("label.usdThreeDSFee"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: 0.4,
        asNumber: true,
        rules: ["onlyPositiveNumber", "maxTwoDecimal"]
      }
    }
  }

  return (
    <FormBuilder.Section
      title={tLocal("title")}
      titleVariant="h3"
    >

      <FormBuilder.Row itemsPerRow={2}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: [
              fieldsConfig.usdSettleCurrency,
              ...settleByUsd ? [
                fieldsConfig.usdBankAccount,
                fieldsConfig.usdBeneficiary,
                fieldsConfig.usdGatewayFee,
                fieldsConfig.usdTokenFee,
                fieldsConfig.usdThreeDSFee
              ] : []
            ]
          })
        }
      </FormBuilder.Row>
    </FormBuilder.Section>
  )
}

export default OnlineMerchantManagementUsdSettlementSection